import Icon from '../components/Icon.vue'

Icon.register({
  'map-marker': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M172.3 501.7c-145.3-210.6-172.3-232.3-172.3-309.7 0-106 86-192 192-192s192 86 192 192c0 77.4-27 99-172.3 309.7-9.5 13.8-29.9 13.8-39.5 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/map-marker.js
// module id = 1545
// module chunks = 0